/**
 * Optimal7 image-with-text overlay reveal:
 * 1) Wait until the banner is in view and the image is loaded.
 * 2) Fade the whole banner (image + button) in over 250ms.
 * 3) Then each heading line slides up with a 5deg rotation, staggered 100ms.
 */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const waitImage = (img) => {
    if (!img) return Promise.resolve();
    if (img.complete && img.naturalWidth > 0) return Promise.resolve();
    return new Promise((resolve) => {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });
  };

  const play = async (banner) => {
    if (banner.dataset.sgBannerPlayed) return;
    banner.dataset.sgBannerPlayed = 'true';

    const img = banner.querySelector('img');
    await waitImage(img);

    if (reduced) {
      banner.style.opacity = '1';
      banner.querySelectorAll('[data-sg-banner-line]').forEach((line) => {
        line.style.opacity = '1';
        line.style.transform = 'none';
      });
      return;
    }

    banner.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 250,
      fill: 'forwards',
      easing: 'ease',
    });

    const headings = banner.querySelectorAll('[data-sg-banner-heading]');
    headings.forEach((heading) => {
      heading.style.opacity = '1';
    });

    const lines = [...banner.querySelectorAll('[data-sg-banner-line]')];
    lines.forEach((line, index) => {
      line.style.transformOrigin = 'top left';
      line.animate(
        [
          { transform: 'translateY(0.5em) rotateZ(5deg)', opacity: 0 },
          { transform: 'translateY(0) rotateZ(0deg)', opacity: 1 },
        ],
        {
          duration: 400,
          delay: 250 + index * 100,
          fill: 'forwards',
          easing: 'ease',
        }
      );
    });
  };

  const observe = (banner) => {
    if (!('IntersectionObserver' in window)) {
      play(banner);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            play(entry.target);
            io.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.25 }
    );
    io.observe(banner);
  };

  const init = () => {
    document.querySelectorAll('[data-sg-image-banner]').forEach(observe);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
